import React, { Component } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
//import '../App.css';
import { ACCESS_TOKEN, RESPONSE, USERDATA, FILE_NAME } from './resources/constant';
import PageNotFound from './common/PageNotFound';

/*LAYOUTS */
import IndexLayout from './MORSApp/MORSLayout/IndexLayout';
import ModuleLayout from './MORSApp/MORSLayout/ModuleLayout';
import NoLayout from './MORSApp/MORSLayout/NoLayout';
import ExpPwdLayout from './MORSApp/MORSLayout/ExpPwdLayout';
import PrintLayout from './MORSApp/MORSLayout/PrintLayout';

/*Components*/
import Home from './MORSApp/Components/Home';
import ExpPassword from './MORSApp/Components/ExpPassword';
import ChangePassword from './MORSApp/Components/ChangePassword';

/*Utilities*/
import SecuredRoute from './Utilities/SecuredRoute';
import MerchantPicker from './Utilities/MerchantPicker';


/*Merchant Reports */
import SearchMerchantReport from './MerchantReports/CreditReports/SearchMerchantReport';
import SearchMerchantSOA from './MerchantReports/CreditReports/SearchMerchantSOA';
import SearchCustomizedReport from './MerchantReports/CreditReports/SearchCustomizedReport';
import SearchCustomerServiceReport from './MerchantReports/CreditReports/SearchCustomerServiceReport';
import SearchTransactionReport from './MerchantReports/CreditReports/SearchTransactionReport';
import SearchCreditNoticeReport from './MerchantReports/CreditReports/SearchCreditNoticeReport';
import SearchTaxReport from './MerchantReports/TaxReports/SearchTaxReport';
import SearchTaxReprint from './MerchantReports/TaxReports/SearchTaxReprint';
import TaxReportFileList from './MerchantReports/ReportFiles/TaxReportFileList';

import SearchISTReport from './MerchantReports/DebitReports/SearchISTReport';

/* Help Reports */
import morsFAQS from './MerchantReports/HelpReports/morsFAQS';
import morsAccessRequest from './MerchantReports/HelpReports/morsAccessRequest';
import morsContactUs from './MerchantReports/HelpReports/morsContactUs';
import bizCardOnlineAccessReq from './MerchantReports/HelpReports/bizCardOnlineAccessReq';
import bizCardOnlineContact from './MerchantReports/HelpReports/bizCardOnlineContact';

/*FileList*/
import ReportFileList from './MerchantReports/ReportFiles/ReportFileList';
import ReportTransactionFileList from './MerchantReports/ReportFiles/ReportFileTransactionList';
import ViewReportFile from './MerchantReports/ReportFiles/ViewReportFile';
import SOAPpdf from './MerchantReports/ReportFiles/SOAPpdf';
import ViewTabularFile from './MerchantReports/ReportFiles/ViewTabularFile';
import MerchFileList from './MerchantReports/ReportFiles/MerchantFileList';
import ViewCreditNoticeFile from './MerchantReports/ReportFiles/ViewCreditNoticeFile'
import ReportDateList from './MerchantReports/ReportFiles/ReportDateList'
import CustomizedReportFileList from './MerchantReports/ReportFiles/CustomizedReportFileList';
import ViewPdf from './MerchantReports/ReportFiles/ViewPdf'

import { logout, changePassword } from './Utilities/WSUtil';



class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
      advisory: [],
      reports: [],
      viewFile: null,
      menuId: '',
      submenuId: '',
      attempt: '',
      lastLogin: '',
      userData: [],
      merchId: '',
      uplDate: '',
      typeReport: '',
      fileName: '',
      searchId: '',
      dateList: [],
      reportData: [],
      //Marlon added
      pdfFile: null,
      taxReportLogs: [],
      cwtReprintParam: null,
      cwtListParam: null
    }
    this.handleLogout = this.handleLogout.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.loadUser = this.loadUser.bind(this);
    this.getReports = this.getReports.bind(this);
    this.getTransactionReports = this.getTransactionReports.bind(this);
    this.menuSubmenu = this.menuSubmenu.bind(this);
    this.setUserData = this.setUserData.bind(this);
    this.expPwdLogout = this.expPwdLogout.bind(this);
    this.setInvalidAttempt = this.setInvalidAttempt.bind(this);
    // AGUMP
    this.getMerchList = this.getMerchList.bind(this);
    this.getCreditReports = this.getCreditReports.bind(this);
    this.getTypeReport = this.getTypeReport.bind(this);
    this.setFileName = this.setFileName.bind(this);
    this.getMerchantMIDList = this.getMerchantMIDList.bind(this);
    this.getReportDateList = this.getReportDateList.bind(this);

    //Marlon Gahol 01/25/2024
    this.getSOAPdf = this.getSOAPdf.bind(this);

    //Marlon Gahol 07/08/2024
    this.getCustomizedReportsList = this.getCustomizedReportsList.bind(this);

    //this.state.fileName = this.state.fileName.bind(this);
    this.getTaxReports = this.getTaxReports.bind(this);
    this.getReportsForPrinting = this.getReportsForPrinting.bind(this);
    this.getPdfFile = this.getPdfFile.bind(this);
    this.getTaxReportRequestLog = this.getTaxReportRequestLog.bind(this);

    this.getCwtReprintParam = this.getCwtReprintParam.bind(this)
    this.getCwtListParam = this.getCwtListParam.bind(this);;
  }


  setUserExp(response) {
    this.setState({ userDetails: response });
    this.props.history.push("/chngPwd");
  }

  menuSubmenu(menuId, submenuId) {

    this.setState({
      menuId: menuId,
      submenuId: submenuId,
    })
  }

  getReports(files) {
    this.setState({
      reports: files
    })
    this.props.history.push("/reportsFileList");
  }

  getCustomizedReportsList(files) {
    //alert('getCustomizedReportsList');
    this.setState({
      reports: files
    })
    this.props.history.push("/customizedReportsFileList");
  }

  getTypeReport(typeRep) {
    this.setState({
      typeReport: typeRep
    })
  }

  getMerchList(files, date) {
    this.setState({
      reports: files,
      uplDate: date
    })
    this.props.history.push("/MerchFileList");
  }

  getCreditReports(merch, date) {
    this.setState({
      merchId: merch,
      uplDate: date
    })
    localStorage.setItem("MerchId", merch);
    localStorage.setItem("UploadDate", date);
    // this.props.history.push("/ViewCreditNoticeFile");
  }

  getTransactionReports(files) {
    this.setState({
      reports: files
    })
    this.props.history.push("/reportsTransactionFileList");
  }
  //AGUMP added 02-04-2020
  getMerchantMIDList(find) {
    this.setState({
      searchId: find
    })
  }

  getReportDateList(response, data) {
    this.setState({
      dateList: response,
      reportData: data
    });

    this.props.history.push("/ReportDateList");
  }
  // AGUMP END

  //MARLON START
  getSOAPdf(merch, date) {
    this.setState({
      merchId: merch,
      uplDate: date
    })
    localStorage.setItem("MerchId", merch);
    localStorage.setItem("UploadDate", date);
    this.props.history.push("/viewSoa");
  }
  //MARLON END

  getTaxReports(reports) {
    this.setState({
      taxReports: reports
    })
  }
  getCwtReprintParam(param) {
    this.setState({ cwtReprintParam: param })
  }
  getCwtListParam(param) {
    this.setState({ cwtListParam: param })
  }
  getTaxReportRequestLog(taxReportLogs) {
    this.setState({
      taxReportLogs: taxReportLogs
    })
  }
  getPdfFile(pdfFile) {
    this.setState({ pdfFile: pdfFile });
  }

  getReportsForPrinting(reports) {
    this.setState({
      forPrinting: reports
    })
  }
  
  componentWillMount() {
    this.loadUser();
  }

  loadUser() {
    if (localStorage.getItem(ACCESS_TOKEN) !== null && localStorage.getItem(RESPONSE) !== null) {
      var x = JSON.parse(localStorage.getItem(RESPONSE));
      localStorage.setItem(USERDATA, JSON.stringify(x.user));
      // AGUMP SORT ADVISORY DATA
      x.advisory.sort((a, b) => new Date(b.dateStamp) - new Date(a.dateStamp));

      this.setState({
        advisory: x.advisory,
        isAuthenticated: true
      });

    }
  }


  handleLogout(redirectTo = "/") {
    var x = JSON.parse(localStorage.getItem(RESPONSE));

    logout(x.user.userId);
    /*
    localStorage.removeItem(ACCESS_TOKEN);    
    localStorage.removeItem(RESPONSE);    
    localStorage.removeItem(USERDATA);
    localStorage.removeItem(FILE_NAME); 
    */
    localStorage.clear();
    this.setState({
      isAuthenticated: false,
      attempt: '',
      lastLogin: '',
    });

    this.props.history.push(redirectTo);
  }

  expPwdLogout(userId) {
    logout(userId);
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(RESPONSE);
    this.setState({
      isAuthenticated: false,
    });

    this.props.history.push("/");
  }

  handleLogin(response) {
    localStorage.setItem(RESPONSE, JSON.stringify(response));
    this.loadUser();
    this.props.history.push("/main");
  }

  setUserData(usrData) {
    this.setState({
      userData: usrData
    });
  }

  setFileName(file) {
    // console.log("FILENAME: "+file)
    //alert("FILENAME: "+file);
    this.setState({
      fileName: file
    });
  }

  setInvalidAttempt(x, y) {
    this.setState({
      attempt: x,
      lastLogin: y,
    })
  }

  render() {
    return (

      <Switch>
        <Route exact path="/" render={(props) =>
          <IndexLayout onLogin={this.handleLogin} setUserData={this.setUserData} setInvalidAttempt={this.setInvalidAttempt}
            attempt={this.state.attempt} lastLogin={this.state.lastLogin} />} >

        </Route>
        <SecuredRoute path="/main" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={Home}
          items={this.state.advisory}
          handleLogout={this.handleLogout}
          menuSubmenu={this.menuSubmenu}
          breadcrumbs={'Merchant Online Reporting System'}>
        </SecuredRoute>
        <SecuredRoute path="/chngExpPwd" authenticated={true}
          layout={ExpPwdLayout} component={ExpPassword}
          handleLogout={this.handleLogout} expPwdLogout={this.expPwdLogout} changePasswordExpired={this.changePasswordExpired}
          breadcrumbs={'Expired Password'}>
        </SecuredRoute>
        <SecuredRoute path="/merchSearchRep" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchMerchantReport}
          getReportDateList={this.getReportDateList}
          getReports={this.getReports}
          searchId={this.searchId}
          getTypeReport={this.getTypeReport}
          handleLogout={this.handleLogout}
          breadcrumbs={'Credit Reports - Merchant Reports'}>
        </SecuredRoute>

        <SecuredRoute path="/ISTReport" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchISTReport} menus={this.state.menus}
          getTypeReport={this.getTypeReport}
          getReports={this.getReports} currentUser={this.state.currentUser} handleLogout={this.handleLogout}
          breadcrumbs={'Debit Reports - IST Reports'}>
        </SecuredRoute>

        <SecuredRoute path="/searchTaxReport" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchTaxReport} menus={this.state.menus}
          getTaxReports={this.getTaxReports} currentUser={this.state.currentUser} handleLogout={this.handleLogout}
          getCwtListParam={this.getCwtListParam}
          breadcrumbs={'Tax Reports - Search CWT Reports'}>

        </SecuredRoute>

        <SecuredRoute path="/taxReportList" authenticated={this.state.isAuthenticated}
          cwtListParam={this.state.cwtListParam}
          layout={PrintLayout} component={TaxReportFileList} menus={this.state.menus}
          getReportsForPrinting={this.getReportsForPrinting}
          forPrinting={this.state.forPrinting}
          getPdfFile={this.getPdfFile}
          items={this.state.taxReports} currentUser={this.state.currentUser} handleLogout={this.handleLogout}
          handleLogout={this.handleLogout}
          breadcrumbs={'Tax Reports - CWT Reports'}>
        </SecuredRoute>

        <SecuredRoute path="/viewPdf" authenticated={this.state.isAuthenticated}
          getPdfFile={this.getPdfFile}
          pdfFile={this.state.pdfFile}
          menus={this.state.menus}
          breadcrumbs={'Tax Reports - View CWT PDF'}
          handleLogout={this.handleLogout}
          layout={PrintLayout} component={ViewPdf}>

        </SecuredRoute>

        <SecuredRoute path="/searchTaxReprint" authenticated={this.state.isAuthenticated}

          getCwtReprintParam={this.getCwtReprintParam}
          getTaxReportRequestLog={this.getTaxReportRequestLog}
          layout={PrintLayout} component={SearchTaxReprint} menus={this.state.menus}
          items={this.state.taxReports} currentUser={this.state.currentUser} handleLogout={this.handleLogout}
          handleLogout={this.handleLogout}
          breadcrumbs={'Tax Reports - Search CWT Reprint'}>

        </SecuredRoute>

        <SecuredRoute path="/customizedReports" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchCustomizedReport} menus={this.state.menus}
          getTypeReport={this.getTypeReport}
          getCustomizedReportsList={this.getCustomizedReportsList} currentUser={this.state.currentUser} handleLogout={this.handleLogout}
          breadcrumbs={'Credit Reports - Customized Reports'}>
        </SecuredRoute>
        <SecuredRoute path="/merchantSOA" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchMerchantSOA} menus={this.state.menus} getTypeReport={this.getTypeReport}
          getReports={this.getReports} currentUser={this.state.currentUser} getCreditReports={this.getCreditReports} handleLogout={this.handleLogout}
          breadcrumbs={'Credit Reports - Merchant Statement of Account'}>
        </SecuredRoute>
        <SecuredRoute path="/merchantCreditNotice" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchCreditNoticeReport} getMerchList={this.getMerchList}
          getTypeReport={this.getTypeReport}
          getReports={this.getReports} handleLogout={this.handleLogout} getCreditReports={this.getCreditReports}
          breadcrumbs={'Credit Reports - Merchant Credit Notice'}>
        </SecuredRoute>

        {/* AGUMP ADD 10-24-2019*/}
        <SecuredRoute path="/merchFileList" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={MerchFileList} UploadDate={this.state.uplDate} SingleId={this.state.merchId}
          handleLogout={this.handleLogout} items={this.state.reports} getCreditReports={this.getCreditReports}
          breadcrumbs={'Credit Reports - Merchant List'}>
        </SecuredRoute>

        <SecuredRoute path="/ViewCreditNoticeFile" authenticated={this.state.isAuthenticated}
          layout={NoLayout} component={ViewCreditNoticeFile} UploadDate={this.state.uplDate} SingleId={this.state.merchId} >
        </SecuredRoute>

        <SecuredRoute path="/ReportDateList" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={ReportDateList}
          items={this.state.dateList} reportData={this.state.reportData}
          getReports={this.getReports}
          UploadDate={this.state.uplDate} SingleId={this.state.merchId}
          handleLogout={this.handleLogout} getCreditReports={this.getCreditReports}
          breadcrumbs={'Report Date List'}>
        </SecuredRoute>


        {/* END */}

        <SecuredRoute path="/molFAQS" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={morsFAQS} pdfFile={this.pdfFile}
          getReports={this.getReports} handleLogout={this.handleLogout}
          breadcrumbs={'Help - MORS Quick Reference Guide'}>
        </SecuredRoute>
        <SecuredRoute path="/molFORMS" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={morsAccessRequest}
          getReports={this.getReports} handleLogout={this.handleLogout}
          breadcrumbs={'Help - MORS Access Request'}>
        </SecuredRoute>
        <SecuredRoute path="/molContactus" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={morsContactUs}
          getReports={this.getReports} handleLogout={this.handleLogout}
          breadcrumbs={'Help - MORS Contact Us'}>
        </SecuredRoute>
        <SecuredRoute path="/bizFORMS" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={bizCardOnlineAccessReq}
          getReports={this.getReports} handleLogout={this.handleLogout}
          breadcrumbs={'Help - BIZ Cards Online Access Request'}>
        </SecuredRoute>
        <SecuredRoute path="/bdobizContactus" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={bizCardOnlineContact}
          getReports={this.getReports} handleLogout={this.handleLogout}
          breadcrumbs={'Help - BIZ Cards Online Contact Us'}>
        </SecuredRoute>
        <SecuredRoute path="/tranDetailsSearch" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchTransactionReport}
          getTypeReport={this.getTypeReport}
          getTransactionReports={this.getTransactionReports} handleLogout={this.handleLogout}
          breadcrumbs={'Credit Reports - Transaction Details'}>
        </SecuredRoute>
        <SecuredRoute path="/customerServiceReports" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={SearchCustomerServiceReport} menus={this.state.menus}
          getReports={this.getReports} currentUser={this.state.currentUser} handleLogout={this.handleLogout}
          breadcrumbs={'Credit Reports - Customer Service Reports'}>
        </SecuredRoute>
        <SecuredRoute path="/reportsFileList" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={ReportFileList} getReports={this.getReports}
          items={this.state.reports} handleLogout={this.handleLogout} viewFile={this.viewFile}
          typeReport={this.state.typeReport} setFileName={this.setFileName}
          breadcrumbs={'List of Reports'}>
        </SecuredRoute>

        <SecuredRoute path="/customizedReportsFileList" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={CustomizedReportFileList} getCustomizedReportsList={this.getCustomizedReportsList}
          items={this.state.reports} handleLogout={this.handleLogout} viewFile={this.viewFile}
          typeReport={this.state.typeReport} setFileName={this.setFileName}
          breadcrumbs={'List of Reports'}>
        </SecuredRoute>

        <SecuredRoute path="/reportsTransactionFileList" authenticated={this.state.isAuthenticated}
          layout={ModuleLayout} component={ReportTransactionFileList}
          items={this.state.reports} handleLogout={this.handleLogout} viewFile={this.viewFile}
          viewTabular={this.viewTabular} breadcrumbs={'Transaction Details'}>
        </SecuredRoute>


        <SecuredRoute path="/viewTabularFile" authenticated={this.state.isAuthenticated}
          layout={NoLayout} component={ViewTabularFile}>

        </SecuredRoute>

        <SecuredRoute path="/viewReportFile" authenticated={this.state.isAuthenticated}
          layout={NoLayout} component={ViewReportFile}>
        </SecuredRoute>


        <SecuredRoute path="/merchantPicker" authenticated={this.state.isAuthenticated}
          layout={NoLayout} getMerchantMIDList={this.getMerchantMIDList} component={MerchantPicker}>
        </SecuredRoute>

        <SecuredRoute path="/viewSoa" authenticated={this.state.isAuthenticated}
          layout={NoLayout} component={SOAPpdf} UploadDate={this.state.uplDate} SingleId={this.state.merchId}> getCreditReports={this.getCreditReports}
        </SecuredRoute>

        <SecuredRoute path="/chngPwd" authenticated={true}
          layout={ModuleLayout} component={ChangePassword}
          items={this.state.reports} viewFile={this.viewFile}
          viewTabular={this.viewTabular} userData={this.state.userData}
          handleLogout={this.handleLogout} expPwdLogout={this.expPwdLogout}
          breadcrumbs={'Profile Maintenance - Change Password'}>
        </SecuredRoute>


        <Route component={PageNotFound}></Route>

      </Switch>

    );
  }
}

export default withRouter(App);
